import { useId, useState } from "react";

interface GrafanaIframeProps {
	readonly panelNumber: number;
	readonly companyId: number;
	readonly height: number;
	readonly selectedRange: {
		from: Temporal.PlainDate | undefined;
		to: Temporal.PlainDate | undefined;
	};
	readonly queryToken: string;
}

export function GrafanaPanel({
	panelNumber,
	height,
	selectedRange: { from, to },
	queryToken,
	companyId,
}: GrafanaIframeProps) {
	const [isTable, setIsTable] = useState(false);
	const id = useId();

	const baseLocation = location.hostname.includes("localhost")
		? "cluster.pre5.wundersolutions.es"
		: location.hostname;

	const vars = new URLSearchParams();
	vars.set("orgId", "1");
	vars.set("timezone", "browser");
	vars.set("var-idEmpresa", String(companyId));
	vars.set("theme", "light");
	vars.set("panelId", `panel-${panelNumber}`);
	vars.set("auth_token", queryToken);
	vars.set("hideLogo", "true");

	if (from) {
		const plainDateTime = from.toPlainDateTime(
			Temporal.PlainTime.from("00:00:00"),
		);
		vars.set("from", plainDateTime.toString());
	}

	if (to) {
		const plainDateTime = to
			.toPlainDateTime(Temporal.PlainTime.from("00:00:00"))
			.add({ days: 1 });

		vars.set("to", plainDateTime.toString());
	}

	const dashboardLink = isTable
		? `https://grafana.${baseLocation}/d-solo/adf66n9/aeiriojav2?${vars.toString()}`
		: `https://grafana.${baseLocation}/d-solo/adf66n9/aeiriojav2?${vars.toString()}`;

	return (
		<div className="grafanaPanel" style={{ height: height - 8 }}>
			<div className="toggleTablePanel" onClick={() => setIsTable(!isTable)}>
				<input
					type="checkbox"
					id={id}
					checked={isTable}
					onChange={() => {
						/* set on top div */
					}}
				/>
				<label htmlFor={id} />
			</div>
			<div className="frameContainer">
				{/* eslint-disable-next-line react/iframe-missing-sandbox -- Needed for grafana to work, apparently*/}
				<iframe sandbox="allow-scripts allow-same-origin" src={dashboardLink} />
			</div>
		</div>
	);
}
